import { Button, Col, Form, Image, Modal, Row, Spin } from 'antd';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import Message from '../../../../config/Message';
import { useState } from 'react';
import InputComponent from '../../../../component/InputComponent';
import { Notification } from '../../../../config/Global';

const TempleImageApproveModal = observer((props) => {
	const { visible, onClose } = props;
	const [form] = Form.useForm();
	const {
		TEMPLE,
		AUTH,
		TEMPLE: { templeImageDetails },
	} = useStore();
	const [imageData, setImageData] = useState([]);
	const [disabled, setDisabled] = useState(true);

	const updateImgState = (imgID, versionNo, isApproved) => {
		let imageDetail = {
			refTablename: 'temple',
			eRefRecordid: visible,
			id: imgID,
			isApproved: isApproved,
			versionNo: versionNo,
		};
		setImageData((data) => [...data, imageDetail]);
	};

	const handleChange = (imgID, versionNo, checkboxValue) => {
		form.validateFields({ validateOnly: true })
			.then(() => {
				setDisabled(false);
			})
			.catch((err) => {
				setDisabled(true);
			});
		if (imageData.length) {
			const isExist = imageData.find((_x) => _x.id === imgID);
			if (isExist) {
				const removeExist = imageData.filter((_x) => _x.id !== imgID);
				setImageData(removeExist);
				updateImgState(imgID, versionNo, checkboxValue);
			} else {
				updateImgState(imgID, versionNo, checkboxValue);
			}
		} else {
			updateImgState(imgID, versionNo, checkboxValue);
		}
	};

	const handleSubmit = () => {
		AUTH.onApproveImage(imageData).then((data) => {
			if (data) {
				Notification.success({ message: Message().ImageApproved });
				TEMPLE.agGrid.api.resetColumnState();
				TEMPLE.setupGrid(TEMPLE.agGrid);
				closeModal();
			}
		});
		// onApproveImage;
	};

	const closeModal = () => {
		form.resetFields();
		setImageData([]);
		TEMPLE.templeImageDetails = null;
		setDisabled(true);
		onClose();
	};

	return (
		<Modal
			title="Temple Image Verification"
			onCancel={closeModal}
			open={visible}
			destroyOnClose
			width={'900px'}
			footer={
				<div>
					<Button
						key={1}
						htmlType="submit"
						type="primary"
						disabled={disabled}
						form="imageApprove"
					>
						Submit
					</Button>
					<Button key={2} onClick={closeModal}>
						Cancel
					</Button>
				</div>
			}
		>
			<Spin spinning={!templeImageDetails}>
				<Form
					id={'imageApprove'}
					layout="vertical"
					form={form}
					onFinish={handleSubmit}
				>
					<Row gutter={24}>
						{templeImageDetails && templeImageDetails.length
							? templeImageDetails.map((imageDetails, index) => {
								return (
									<Col
										span={4}
										style={{ marginBottom: '20px' }}
									>
										<Image.PreviewGroup>
											<Image
												src={`${imageDetails.bunnyLink}?width=300&&aspect_ratio=1:1`}
												alt={imageDetails.filename}
											/>
											<div
												style={{
													marginTop: '8px',
													marginBottom: '5px',
													textAlign: 'center',
													wordBreak: 'break-word',
													fontSize: '12px',
													backgroundColor: '#f0f0f0',
													padding: '3px 8px',
													borderRadius: '10px',
													lineHeight: '16px',
												}}
											>
												{imageDetails.description || '-'}
											</div>
											<div
												style={{
													marginTop: '10px',
													textAlign: 'center',
												}}
											>
												<InputComponent
													type={'checkbox'}
													defaultChecked={
														imageDetails.isApproved
													}
													name={`checkbox_${index}`}
													label={'Approve'}
													onChange={(e) =>
														handleChange(
															imageDetails.id,
															imageDetails.versionNo,
															e.target.checked
														)
													}
												/>
											</div>
										</Image.PreviewGroup>
									</Col>
								);
							})
							: Message().noRecord}
					</Row>
				</Form>
			</Spin>
		</Modal>
	);
});

export default TempleImageApproveModal;
